import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/reportes',
  documento: 'reports',
  acceso: 'sesion',
  filas: ['113'],
  cita: 'Areas/Reports/Controllers/DashboardController.cs',
} satisfies RutaProd;
